import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { EmpresasPage } from '../../pages/empresas/empresas';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { UserlinPage } from '../../pages/userlin/userlin';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';



/**
 * Generated class for the ObrasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-user',
  templateUrl: 'user.html',
})
export class UserPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",pass1: "",valor1: "*000000"}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  users;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  obrasKeys;
  values:Array<string> = [];



  
  constructor(
    public myParam: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public funciones:FuncionesProvider,
    public variables:VariablesProvider
    ) {                    
            
            this.variables.btatras = true;
            var sum = 0;
            var horas=0;
            
          
  
      this.myForm = this.fb.group({

      id: [''],
      nombre: ['' ],
      pass: ['' ],
      valor: ['' ]

      
     });

 this.myForm1 = this.fb.group({

      id1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      pass1: ['', [Validators.required]],
      valor1: ['', [Validators.required]],
     });
   

    this.obteneruser(this.valo);

  }

   
  obteneruser(filtro){



    this.funciones.obtieneusers(filtro).then(
          data => {

          this.users = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   editarusers(index){

     console.log(this.users[index].ID);
     console.log(this.users[index].PASS);


    this.funciones.editarusers(this.users[index]).then(
          data => {
            console.log(data);
      
            this.obteneruser(this.valo);

             
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  registro(){


   this.funciones.grabarusers(this.formulario.nombre1,this.formulario.pass1,"SNNNNNNN","SNNNN").then(
     data => {
            this.resultado = data;
            console.log(data);
            this.obteneruser(this.valo);
            this.formulario.nombre1="";
        })


  }

   expandir(valor,nombre,i){

      var valoranterior;
      var valoranterior2;
      var usuario;

      valoranterior = this.users[i].VALOR;
      valoranterior2 = this.users[i].VALOR2;
      usuario = this.users[i];

            let myModal = this.modalCtrl.create(UserlinPage, {
              'codigo': valor,
              'id':i,
              'rsx': this.users,
              'tabla': "userlin",
              'caption': 'Detalles del Usuario (' + nombre + ')'
            }
            );

            myModal.onDidDismiss((data: any) => { 


              this.editarusers(i);

            }); 
            myModal.present();

  }

   borrar(codigo,nombre){
      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar el usuario? '  + codigo + ' -> ' + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {
               this.funciones.delusers(codigo).then(
                   data => {
                    
                    this.obteneruser(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
  }

ponencampo(campo:string, value:string):void{
      
      switch (campo) {
         case "VALOR":
           this.formulario.valor1 = value;
           break;
         
         default:
           // code...
           break;
       }
     
    }
 
 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
         case "ID":
           this.users[index].ID = value;
           break;
         case "NOMBRE":
           this.users[index].NOMBRE = value;
           break;
         case "PASS":
           this.users[index].PASS = value;
           break;
       
         
         default:
           // code...
           break;
       }
     
    }



openempresa(){
       
            let myModal = this.modalCtrl.create(EmpresasPage, {
              'caption': 'Crear una nueva empresa.'
            }
            );

            myModal.onDidDismiss((data: any) => { 
                this.navCtrl.setRoot(this.navCtrl.getActive().component);   
            }); 
            myModal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts